var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "new-journal"
  }, [_vm.isPreloadCreation ? [_c('PreloaderOnCreation')] : [_c('Header'), _vm.article ? _c('article', {
    key: _vm.article.id,
    staticClass: "article-redesign"
  }, [_c('div', {
    staticClass: "article-image",
    style: {
      backgroundImage: 'url(\'' + _vm.article.image + '\')'
    }
  }, [_c('div', {
    staticClass: "article-title-container article-container"
  }, [_c('div', {
    staticClass: "article-title-wrapper"
  }, [_c('div', {
    staticClass: "article-section"
  }, [_vm._v(_vm._s(_vm.article.category_name))]), _c('div', {
    staticClass: "article-title",
    domProps: {
      "innerHTML": _vm._s(_vm.article.card_name || _vm.article.name)
    }
  })])])]), _c('div', {
    staticClass: "article-text-container article-container"
  }, [_c('div', {
    staticClass: "article-left-block"
  }, [_c('div', {
    staticClass: "article-text",
    domProps: {
      "innerHTML": _vm._s(_vm.article.preview_text)
    }
  }), _c('br'), _c('div', {
    staticClass: "article-text",
    domProps: {
      "innerHTML": _vm._s(_vm.article.detail_text)
    }
  }), _vm.article.marquiz && _vm.article.category === '12234458' ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "25px"
    }
  }, [_c('a', {
    staticClass: "marquiz__button marquiz__button_blicked marquiz__button_rounded marquiz__button_shadow",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.marquiz($event);
      }
    }
  }, [_vm._v("Пройти тест")])]) : _vm._e()]), _c('div', {
    staticClass: "article-right-block"
  }, [_vm.banner ? _c('a', {
    staticClass: "article-banner",
    style: {
      backgroundImage: 'url(\'' + _vm.banner.image + '\')'
    },
    attrs: {
      "href": _vm.banner.link,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "article-banner-text",
    domProps: {
      "innerHTML": _vm._s(_vm.banner.text)
    }
  })]) : _vm._e()])]), _c('share', {
    key: 'share_' + _vm.article.id,
    attrs: {
      "article": _vm.article
    }
  }), _vm.otherArticles && _vm.otherArticles.length > 0 ? [_c('hr'), _c('div', {
    staticClass: "other-articles"
  }, [_c('div', {
    staticClass: "article-container _desktop"
  }, [_c('cards-section', {
    attrs: {
      "code": "other",
      "title": "Вам также может понравиться",
      "items": _vm.otherArticles
    }
  })], 1), _c('div', {
    staticClass: "_phone also-interested-section"
  }, [_c('mobile-section-slider', {
    attrs: {
      "code": "other-mobile",
      "name": "Вам также может понравиться",
      "link": "/category/lifehacks",
      "items": _vm.otherArticles,
      "no-gray": false,
      "no-margin": true,
      "gray-bg": true
    }
  })], 1)])] : _vm._e(), _c('hr', {
    staticStyle: {
      "margin-top": "0"
    }
  })], 2) : _vm._e()]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }